import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/global-config';

import { InternalServerErrorView } from 'src/sections/error';

function InternalServerErrorPage() {
  return (
    <>
      <Helmet>
        <title>500 - Internal Server Error | {CONFIG.appName}</title>
      </Helmet>
      <InternalServerErrorView />
    </>
  );
}

export default InternalServerErrorPage;
